__turbopack_context__.v({
  "icon": "jO78wq_icon",
  "link": "jO78wq_link",
});
